import { LazyLoader, Modal } from '@bp/ui-components';
import { FragmentType } from 'client/gql';
import { Suspense, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { GroupViewersForm, GroupViewersFormFragment } from '../forms/GroupViewersForm';

type GroupViewersModalProps = {
  isOpen: boolean;
  groupUuid: string;
  schoolYearUuid: string;
  onClose: () => void;
  query: FragmentType<typeof GroupViewersFormFragment> | undefined;
};

export const GroupViewersModal = ({ isOpen, groupUuid, schoolYearUuid, onClose, query }: GroupViewersModalProps) => {
  const { t } = useTranslation();

  const [loading, setLoading] = useState<boolean>(false);

  return (
    <Modal loading={loading} isOpen={isOpen} onRequestClose={onClose} title={t('groups.editViewers')}>
      <Suspense fallback={<LazyLoader embedded forceHeight='58vh' />}>
        <GroupViewersForm
          query={query}
          groupUuid={groupUuid}
          schoolYearUuid={schoolYearUuid}
          onLoad={setLoading}
          onClose={onClose}
        />
      </Suspense>
    </Modal>
  );
};
